import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import './i18n';

import theme from 'theme';

ReactDOM.render(
  <React.StrictMode>
    <App theme={theme} />
  </React.StrictMode>,
  document.getElementById('root')
);
